import GraphQLJSClient from 'graphql-js-client';
import typeBundle from './types';
import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import {BehaviorSubject, Subject, Subscription} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {UserContext} from '../user-context';
import {JwtHelperService} from '@auth0/angular-jwt';
import {Router} from '@angular/router';
import {Collection} from '../../models/collection.model';
import {Product} from '../../models/product.model';
import {GridDataResult} from '@progress/kendo-angular-grid';
import {ApiService} from '../api';

@Injectable()
export class ShopifyService extends BehaviorSubject<GridDataResult> {
  client: GraphQLJSClient = null;

  collectionSubject: Subject<Collection> = new Subject<Collection>();
  storeLinkObserver: BehaviorSubject<string> = new BehaviorSubject(null);
  collectionsSubject: BehaviorSubject<Collection[]> = new BehaviorSubject([]);
  productsSubject: BehaviorSubject<Product[]> = new BehaviorSubject([]);
  currentCollection: Collection;

  public subscription: Subscription;

  public collections:Collection[];
  public products:Product[];
  public filtered:Product[];
  currentSearch = '';

  constructor(private api: ApiService, private userContext: UserContext) {
    super((<GridDataResult>{
      data: [],
      total: 0
    }));
  }

  /*
  public getList(page: number, limit: number, search?: string) {
    if ( search && search !== this.currentSearch ) {
      this.filtered = this.products.filter(p => p.title.toLowerCase().indexOf(search.toLowerCase()) >= 0);
    }
    if ( !search ) {
      this.filtered = [];
    }
    this.currentSearch = search;
    if ( this.currentSearch ) {
      let start = (page - 1) * limit > this.filtered.length ? 0 : (page - 1) * limit;
      super.next({total: this.filtered.length, data: this.filtered.slice(start, start + limit)});
    } else {
      console.log("Showing non filtered.");
      super.next({total:this.products.length, data:this.products.slice((page - 1) * limit, ((page - 1) * limit)  + limit)});
    }
    console.log("This current search '" + this.currentSearch + "'");
  }
*/

  public getList(page: number, limit: number, search?: string, collection?:Collection) {
    if ( search && search !== this.currentSearch ) {
      if( collection ) {
        this.filtered = collection.products.filter(p => p.title.toLowerCase().indexOf(search.toLowerCase()) >= 0);
        //console.log("products: " + JSON.stringify(this.filtered, null,4));
      } else {
        this.filtered = this.products.filter(p => p.title.toLowerCase().indexOf(search.toLowerCase()) >= 0);
      }
    }
    if ( !search ) {
      if( collection ) {
        this.filtered = collection.products.filter(p => p.title.toLowerCase().indexOf(search.toLowerCase()) >= 0);
        //console.log("products: " + JSON.stringify(this.filtered, null,4));
      } else {
        this.filtered = this.products.filter(p => p.title.toLowerCase().indexOf(search.toLowerCase()) >= 0);
      }
    }
    this.currentSearch = search;
    if ( this.currentSearch ) {
      let start = (page - 1) * limit > this.filtered.length ? 0 : (page - 1) * limit;
      super.next({total: this.filtered.length, data: this.filtered.slice(start, start + limit)});
    } else if (this.filtered) {
      let start = (page - 1) * limit > this.filtered.length ? 0 : (page - 1) * limit;
      super.next({total: this.filtered.length, data: this.filtered.slice(start, start + limit)});
    } else {
      console.log("Showing non filtered.");
      super.next({total:this.products.length, data:this.products.slice((page - 1) * limit, ((page - 1) * limit)  + limit)});
    }
    console.log("This current search '" + this.currentSearch + "'");
  }

  setShopForCountry(country: string ): void {
    let token = (country || 'us').toLowerCase() === 'ca' ?
      '051062cf8d6304c0d15767357d42e1e7' : '6af9b32c5f5ec088dbfd3aeb8d47d63c';
    let url =  (country || 'us').toLowerCase() === 'ca' ?
      'https://shop.fitscanada.com/api/graphql' : 'https://shop.fitsamerica.com/api/graphql';
    let shopify = (this.userContext.account.integrations || {}).shopify;
    if( shopify ) {
      if( shopify.enabled && shopify.token && shopify.url ) {
        url = shopify.url + '/api/graphql';
        token = shopify.token;
      }
    }
    this.client = new GraphQLJSClient(typeBundle, {
      url: url,
      fetcherOptions: {
        headers: {
          'X-Shopify-Storefront-Access-Token': token
        }
      }
    });

    this.getCollections().then( response => {
      this.collections = response;

      this.products = this.collections.reduce((a, b) => [...a, ...b.products], [])
      this.products.sort((a,b) => a.title.localeCompare(b.title));
      this.collectionsSubject.next(this.collections);
      this.productsSubject.next(this.products);
      super.next({total:this.products.length,data:this.products.slice(0,5)});
    });
    /*
    this.getProducts().then( response => {
      this.products = response.sort((a,b) => a.title.localeCompare(b.title));
      super.next({total:this.products.length,data:this.products.slice(0,5)});
    });
    */
    console.log("Set country: " + country);
  }

  getProductById(_id): Promise<Product> {

    let client = this.client;

    let query = client.query((root) => {
      root.add('node', { args: { id: _id }, alias: 'product' }, (node) => {
        node.add('id');
        node.addInlineFragmentOn('Product', (Product) => {
          Product.add('title');
          Product.add('createdAt');
          Product.add('description');
          Product.add('descriptionHtml');
          Product.add('descriptionPlainSummary');
          Product.add('productType');
          Product.add('publishedAt');
          Product.add('tags');
          Product.add('handle');
          Product.add('updatedAt');
          Product.add('vendor');
          // Product.add('priceRange');
          Product.addConnection('images', { args: { first: 250 } }, (images) => {
            images.add('src');
            images.add('id');
            images.add('altText');
          })
          Product.addConnection('variants', { args: { first: 250 } }, (variants) => {
            variants.add('id');
            variants.add('product', (variantProduct) => {
              variantProduct.add('title');
              variantProduct.add('id');
              variantProduct.add('handle');
            });
            variants.add('title');
            variants.add('price');
            variants.add('sku');
            variants.add('compareAtPrice');
            variants.add('image', (image) => {
              image.add('src');
              image.add('id');
              image.add('altText');
            })
          })
        })
      })
    });

    return client.send(query).then(({ model, data }) => {
      return client.fetchAllPages(model.product, { pageSize: 250 })
    });

  }

  getCollections(): Promise<Collection[]> {

    console.log("Getting collections *********");
    const query = this.client.query((root) => {
      root.add('shop', (shop) => {
        shop.addConnection('collections', { args: { first: 250 } }, (collections) => {
          collections.add('id');
          collections.add('title');
          collections.add('handle');
          collections.add('image', (image) => {
            image.add('src');
            image.add('id');
            image.add('altText');
          });
          collections.addConnection('products', {args: {first: 250}}, (products) => {
            products.add('id');
            products.add('title');
            products.add('handle');
            //products.add('description');
            products.add('descriptionHtml');
            //products.add('descriptionPlainSummary');
            products.addConnection('images', {args: {first: 250}}, (images) => {
              images.add('src');
              images.add('id');
              images.add('altText');
            });
            products.addConnection('variants', {args: {first: 250}}, (variants) => {
              variants.add('id');
              //variants.add('product');
              variants.add('product', (variantProduct) => {
                variantProduct.add('title');
                variantProduct.add('id');
                variantProduct.add('handle');
                //variantProduct.add('description');
                variantProduct.add('descriptionHtml');
                //variantProduct.add('descriptionPlainSummary');
              });
              variants.add('title');
              variants.add('price');
              variants.add('sku');
              variants.add('image', (image) => {
                image.add('src');
                image.add('id');
                image.add('altText');
              });
            });
          });
        });
      });
    });

    return this.client.send(query).then(({ model, data }) => {
      return this.client.fetchAllPages(model.shop.collections, { pageSize: 20 });
    });

  }


  getProducts(): Promise<Product[]> {
    let query = this.client.query((root) => {
      root.add('shop', (shop) => {
        shop.addConnection('products', {args: {first: 250}}, (products) => {
          products.add('id');
          products.add('title');
          products.add('handle');
          products.addConnection('images', {args: {first: 250}}, (images) => {
            images.add('src');
            images.add('id');
            images.add('altText');
          });
        });
      });
    });

    return this.client.send(query).then(({model, data}) => {
      return this.client.fetchAllPages(model.shop.products, {pageSize: 20});
    });

  }

  createCheckout(_lineItems, locationId): Promise<any> {

    const _lineItemsForCheckout = _lineItems.map(item => { return { 'variantId': item.variantId, 'quantity': item.quantity } })

    const input = this.client.variable('input', 'CheckoutCreateInput!');

    const mutation = this.client.mutation('myMutation', [input], (root) => {
      root.add('checkoutCreate', { args: { input } }, (checkoutCreate) => {
        checkoutCreate.add('userErrors', (userErrors) => {
          userErrors.add('message'),
            userErrors.add('field')
        })
        checkoutCreate.add('checkout', (checkout) => {
          checkout.add('id'),
            checkout.add('webUrl'),
            checkout.addConnection('lineItems', { args: { first: 250 } }, (lineItems) => {

              lineItems.add('variant', (variant) => {
                variant.add('title'),
                  variant.add('price'),
                  variant.add('sku')
              }),
                lineItems.add('quantity')
            }
            )
        })
      })
    })

    const locationAttribute = {key: 'location', value: locationId || 'default'}

    return this.client.send(mutation, { 'input': { lineItems: _lineItemsForCheckout, customAttributes: [locationAttribute]} });
  }

  fetchCheckout(_checkoutid): Promise<any> {

    const id = this.client.variable('checkoutId', 'ID!');

    let query = this.client.query((root) => {
      root.add('node', { args: { id: _checkoutid }, alias: 'checkout' }, (node) => {
        node.add('id');
        node.addInlineFragmentOn('Checkout', (Checkout) => {
          Checkout.add('webUrl');
          Checkout.add('subtotalPrice'),
            Checkout.add('totalTax'),
            Checkout.add('totalPrice'),
            Checkout.addConnection('lineItems', { args: { first: 250 } }, (lineItems) => {
              lineItems.add('variant', (variant) => {
                variant.add('title'),
                  variant.add('image', (image) => image.add('src')),
                  variant.add('price'),
                  variant.add('sku')
              }),
                lineItems.add('quantity')
            })
        })
      })
    });

    return this.client.send(query, { checkoutId: _checkoutid })
  }

  addVariantsToCheckout(_checkoutid, _lineItems): Promise<any> {

    const checkoutId = this.client.variable('checkoutId', 'ID!');
    const _lineItemsForCheckout = _lineItems.map(item => { return { 'id': item.id, 'variantId': item.variantId, 'quantity': item.quantity } })
    const lineItems = this.client.variable('lineItems', '[CheckoutLineItemInput!]!');

    const mutation = this.client.mutation('myMutation', [checkoutId, lineItems], (root) => {
      root.add('checkoutLineItemsAdd', { args: { checkoutId, lineItems } }, (checkoutLineItemsAdd) => {

        checkoutLineItemsAdd.add('userErrors', (userErrors) => {
          userErrors.add('message'),
            userErrors.add('field');
        });

        checkoutLineItemsAdd.add('checkout', (checkout) => {
          checkout.add('webUrl'),
            checkout.add('subtotalPrice'),
            checkout.add('totalTax'),
            checkout.add('totalPrice'),
            checkout.addConnection('lineItems', { args: { first: 250 } }, (lineItems) => {
              lineItems.add('variant', (variant) => {
                variant.add('title'),
                  variant.add('image', (image) => image.add('src')),
                  variant.add('price'),
                  variant.add('sku')
              }),
                lineItems.add('quantity')
            })
        })
      })
    });

    return this.client.send(mutation, { checkoutId: _checkoutid, lineItems: _lineItemsForCheckout });

  }

  removeLineItem(_checkoutid, _lineItemId): Promise<any> {

    const checkoutId = this.client.variable('checkoutId', 'ID!');
    const lineItemIds = this.client.variable('lineItemIds', '[ID!]!');

    const mutation = this.client.mutation('myMutation', [checkoutId, lineItemIds], (root) => {
      root.add('checkoutLineItemsRemove', { args: { checkoutId, lineItemIds } }, (checkoutLineItemsRemove) => {

        checkoutLineItemsRemove.add('userErrors', (userErrors) => {
          userErrors.add('message'),
            userErrors.add('field');
        }),

          checkoutLineItemsRemove.add('checkout', (checkout) => {
            checkout.add('webUrl'),
              checkout.add('subtotalPrice'),
              checkout.add('totalTax'),
              checkout.add('totalPrice'),
              checkout.addConnection('lineItems', { args: { first: 250 } }, (lineItems) => {
                lineItems.add('variant', (variant) => {
                  variant.add('title'),
                    variant.add('image', (image) => image.add('src')),
                    variant.add('price'),
                    variant.add('sku')
                }),
                  lineItems.add('quantity')
              })
          })
      })
    });

    return this.client.send(mutation, { checkoutId: _checkoutid, lineItemIds: [_lineItemId] });

  }

  updateLineItem(_checkoutid, _lineItems): Promise<any> {

    const _lineItemsForCheckout = _lineItems.map(item => { return { 'id': item.id, 'variantId': item.variantId, 'quantity': item.quantity } })

    const checkoutId = this.client.variable('checkoutId', 'ID!');
    const lineItems = this.client.variable('lineItems', '[CheckoutLineItemUpdateInput!]!');

    const mutation = this.client.mutation('myMutation', [checkoutId, lineItems], (root) => {
      root.add('checkoutLineItemsUpdate', { args: { checkoutId, lineItems } }, (checkoutLineItemsUpdate) => {

        checkoutLineItemsUpdate.add('userErrors', (userErrors) => {
          userErrors.add('message'),
            userErrors.add('field');
        });

        checkoutLineItemsUpdate.add('checkout', (checkout) => {
          checkout.add('webUrl'),
            checkout.add('subtotalPrice'),
            checkout.add('totalTax'),
            checkout.add('totalPrice'),
            checkout.addConnection('lineItems', { args: { first: 250 } }, (lineItems) => {
              lineItems.add('variant', (variant) => {
                variant.add('title'),
                  variant.add('image', (image) => image.add('src')),
                  variant.add('price'),
                  variant.add('sku')
              }),
                lineItems.add('quantity')
            })
        })
      })
    });

    return this.client.send(mutation, { checkoutId: _checkoutid, lineItems: _lineItemsForCheckout });
  }

}
